module.exports = __webpack_public_path__ + "img/system2-2.184a36cc.svg";